export const DOMAIN = 'consentConfigDetails.configuration';
